module.exports = __webpack_public_path__ + "static/media/3.10ed3cf6.png";